import React, { useState } from 'react';
import { ChangeEvent } from 'react';
import { AbbreviatedItem } from '../../types/item_types';
import classes from './ItemMenu.module.css';
import DebouncingInput from '../UI/DebouncingInput';

const InfoSectionLine = ({ isLast, item, allowNewItem, addLine, deleteLine, editItemCat, editItemName, editItemManufacturer, modelsLine, itemSuggestions, onFetchSuggestions, onClearSuggestions, getAutomaticCat }
    : { 
        isLast: boolean,
        item: AbbreviatedItem,
        allowNewItem?: boolean,
        addLine: () => void,
        deleteLine: () => void,
        editItemCat: (cat: string) => void,
        editItemName: (name: string) => void,
        editItemManufacturer?: (manufacturer: string) => void,
        first?: boolean,
        modelsLine?: boolean,
        itemSuggestions?: AbbreviatedItem[],
        onFetchSuggestions?: (value: string, field: string) => any,
        onClearSuggestions?: () => any,
        getAutomaticCat?: () => string,
    }) => {

    const [ itemCatSearchText, setItemCatSearchText] = useState<string | null>(null);
    const [ itemNameSearchText, setItemNameSearchText] = useState<string | null>(null);    
    const [ editingNewItem, setEditingNewItem ] = useState(false);
    
    const handleCatInput = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        editItemCat(event.target.value);
    };
    const handleNameInput = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        editItemName(event.target.value);
    };
    const handleManufacturerInput = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        if (editItemManufacturer) {
            editItemManufacturer(event.target.value);
        }
    };
    const handleClick = () => {
        if (isLast && item.cat.length > 0 && item.name.length > 0) {
            addLine();
        }
    }
    const conditionalDeleteUponBlur = () => {
        if (item.cat.length === 0 && item.name.length === 0) {
            deleteLine();
        }
    }

    
    const getCatSuggestions = (typedValue: string | null, getAutomaticCat?: () => string) => {
        const res = (allowNewItem && !itemSuggestions?.some(s => s.cat === typedValue)) ?
            [ {
                cat: editingNewItem ? item.cat : (typedValue?.length ? typedValue : (getAutomaticCat?.() ?? '')),
                name: editingNewItem ? item.name : "",
                isNew: true,
                isAuto: !typedValue?.length,
            }, ...(itemSuggestions ?? [])] : itemSuggestions;
        return res;
    };

    const getNameSuggestions = (typedValue: string | null) => {
        const res = (allowNewItem && !itemSuggestions?.some(s => s.name === typedValue)) ?
            [ {
                
                cat: editingNewItem ? item.cat : '',
                name: typedValue,
                isNew: true,
            }, ...(itemSuggestions ?? [])] : itemSuggestions;
        return res;
    };

    return (
        <div className={classes.infoSectionLine} style={{ gridTemplateColumns: modelsLine ? "1fr 1fr 1fr 2.5rem" : "1fr 2fr 2.5rem" }}>
            {modelsLine && <input type="text" placeholder='יצרן' value={item.manufacturer} onChange={handleManufacturerInput} onBlur={() => conditionalDeleteUponBlur()} />}
            {onFetchSuggestions ?
            <DebouncingInput
                id="searchCat"
                className={classes.autosuggest}
                inputValue={itemCatSearchText ?? item.cat ?? ''}
                onValueChanged={(val: any) => setItemCatSearchText(val)}
                onValueErased={() => { deleteLine(); setEditingNewItem(false); }}
                onSuggestionSelected={(s: any) => {
                    editItemCat(s.cat);
                    if (!editingNewItem && s.isNew) {
                        editItemName("");
                    } else {
                        editItemName(s.name);
                    }
                    setItemCatSearchText(null);
                    setEditingNewItem(s.isNew);
                }}
                getSuggestionValue={s => s.cat}
                placeholder={modelsLine ? 'מק"ט יצרן' : 'מק"ט'}
                suggestions={getCatSuggestions(itemCatSearchText, getAutomaticCat)}
                shouldRenderSuggestions={() => true}
                onFetchSuggestions={s => onFetchSuggestions?.(s, 'cat')}
                renderSuggestion={s => <span>{s.cat} {s.name}{s.isNew ? (s.isAuto ? ` (פריט חדש ללא מק"ט)` : ` (פריט חדש)`): ``}</span>}
                onClearSuggestions={onClearSuggestions}
                onBlur={() => {
                    if (editingNewItem && itemCatSearchText) {
                        editItemCat(itemCatSearchText);
                    }
                    setItemCatSearchText(null);
                    conditionalDeleteUponBlur();
                }}
            /> :
            <input type="text" placeholder={modelsLine ? 'מק"ט יצרן' : 'מק"ט'} value={item.cat} onChange={handleCatInput} onBlur={() => conditionalDeleteUponBlur()} />
            }
            {onFetchSuggestions ?
            <DebouncingInput
                id="searchName"
                className={classes.autosuggest}
                inputValue={itemNameSearchText ?? item.name ?? ''}
                onValueChanged={(val: any) => setItemNameSearchText(val)}
                onValueErased={() => { deleteLine(); setEditingNewItem(false); }}
                onSuggestionSelected={(s: any) => {
                    if (!editingNewItem && s.isNew) {
                        editItemCat("");
                    } else {
                        editItemCat(s.cat);
                    }
                    editItemName(s.name);
                    setItemNameSearchText(null);
                    setEditingNewItem(s.isNew);
                }}
                getSuggestionValue={s => s.name}
                placeholder={modelsLine ? 'שם דגם' : 'שם'}
                suggestions={itemNameSearchText ? getNameSuggestions(itemNameSearchText) : itemSuggestions}
                onFetchSuggestions={s => onFetchSuggestions?.(s, 'name')}
                renderSuggestion={s => <span>{s.cat} {s.name}{s.isNew ? ` (פריט חדש)` : ``}</span>}
                onClearSuggestions={onClearSuggestions}
                onBlur={() => {
                    if (editingNewItem && itemNameSearchText) {
                        editItemName(itemNameSearchText);
                    }                    
                    setItemNameSearchText(null);
                    conditionalDeleteUponBlur();
                }}
            /> :
            <input type="text" placeholder={modelsLine ? 'שם דגם' : 'שם'} value={item.name} onChange={handleNameInput} onBlur={() => conditionalDeleteUponBlur()} />
            }
            <div onClick={handleClick} className={(item.cat.length > 0 && item.name?.length > 0) ? classes.infoSectionPlusClickable : classes.infoSectionPlusGrayed} style={{ display: isLast ? "flex" : "none" }}>+</div>
        </div>
    )
};

export default React.memo(InfoSectionLine);